import { AbstractRenderer, BusinessComponent, BusinessComponentOptions, ComponentData, PageBreak } from '@blk/simba';

/**
 * Util business component for page breaking by checking for component data visibility
 */
export class PageBreakBusinessComponent extends BusinessComponent {

	constructor(
		public name: string,
		public dataComponentId: string,
		public tabId: string,
		public isComponentDataVisibleFunction: (data: any, tabId: string) => boolean,
		public isConfigAvailable: boolean = false,
		public visible: boolean = true
	) {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible, componentId: dataComponentId }));
	}

	public buildComponent(componentData: ComponentData): AbstractRenderer<SVGGElement>[] {
		if (this.isComponentDataVisibleFunction(componentData, this.tabId) || this.isConfigAvailable) {
			return [new PageBreak()];
		} else {
			return [];
		}
	}
}
